
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Leagues from "../../modules/leagues/Leagues";
export default Leagues;
import { ModeIds } from "@chesshotel/constants";
const getStaticProps = async () => {
    return {
        props: { modeId: ModeIds.BULLET },
    };
};

    async function __Next_Translate__getStaticProps__1a18c1f76b5__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/leagues/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a18c1f76b5__ as getStaticProps }
  